import React from "react";
import OfferDetails from "../../components/OfferDetails";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../services/react-query/queryKeys";
import { offerDetails } from "../../network/offer";
import { useTranslation } from "react-i18next";
import CartLoading from "../../components/PlaceHolder/CartLoading";
import { useParams } from "react-router";

const OfferDetailsPage = () => {
  const { i18n } = useTranslation();
  const { id: code } = useParams();

  const { data: offerData, isLoading } = useQuery({
    queryKey: [queryKeys.listOffers, code, i18n],
    queryFn: () => offerDetails(code),
    enabled: !!i18n && !!code,
  });

  if (isLoading) {
    return <CartLoading isLoading={isLoading} />;
  }

  return (
    <OfferDetails data={offerData?.data} />
  );
};

export default OfferDetailsPage;